import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue'
import { ElScrollbar } from 'element-plus'

interface ScrollbarInstance {
  $el?: HTMLElement
  wrapRef?: HTMLDivElement | { value?: HTMLDivElement }
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CandidateScrollbar',
  props: {
    height: { default: '100%' },
    always: { type: Boolean, default: false }
  },
  setup(__props: any) {

const scrollbarRef = ref<ScrollbarInstance | null>(null)
const isVerticalOverflowing = ref(false)
let resizeObserver: ResizeObserver | null = null

function getWrapElement(): HTMLDivElement | null {
  const exposedWrap = scrollbarRef.value?.wrapRef
  if (exposedWrap instanceof HTMLDivElement) return exposedWrap
  if (exposedWrap?.value instanceof HTMLDivElement) return exposedWrap.value
  return scrollbarRef.value?.$el?.querySelector<HTMLDivElement>('.el-scrollbar__wrap') || null
}

function updateVerticalOverflow() {
  const wrap = getWrapElement()
  const view = wrap?.querySelector<HTMLElement>('.el-scrollbar__view')
  const hasOverflow = Boolean(
    wrap && view && Math.max(view.offsetHeight, view.scrollHeight) > wrap.clientHeight + 1,
  )
  if (isVerticalOverflowing.value !== hasOverflow) {
    isVerticalOverflowing.value = hasOverflow
  }
}

onMounted(async () => {
  await nextTick()
  const wrap = getWrapElement()
  const view = wrap?.querySelector<HTMLElement>('.el-scrollbar__view')
  updateVerticalOverflow()
  if (!wrap || !view || typeof ResizeObserver === 'undefined') return
  resizeObserver = new ResizeObserver(updateVerticalOverflow)
  resizeObserver.observe(wrap)
  resizeObserver.observe(view)
})

onBeforeUnmount(() => {
  resizeObserver?.disconnect()
  resizeObserver = null
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ElScrollbar), _mergeProps({
    ref_key: "scrollbarRef",
    ref: scrollbarRef,
    height: _ctx.height,
    always: _ctx.always,
    class: { 'is-vertical-overflowing': isVerticalOverflowing.value }
  }, _ctx.$attrs), {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["height", "always", "class"]))
}
}

})